export enum ContractStatusEnum {
    PENDING = 'pending',
    READY_FOR_DELIVERY = 'ready_for_delivery',
    SIGNED = 'signed',
}